import { memo } from "react";

import { Button, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { settingsActionsKeys } from "./automationKeys";
import * as SC from "./styles";
import { CANCEL, SAVE, TOOLTIP_DISABLED_TEXT } from "./texts";
import type { SettingsActionsSchema } from "./types";

const SettingsActions = memo(({ onCancel, onSave, isDisabled, isLoading, zIndex }: SettingsActionsSchema) => (
    <SC.SettingsActionsContainer
        zIndex={zIndex}
        data-automation={settingsActionsKeys.container}
    >
        <SC.ButtonGroupWrapper>
            <Button
                type="flat"
                onClick={onCancel}
                dataAutomation={settingsActionsKeys.cancel}
            >
                <SC.CancelBtnText>{translate(CANCEL)}</SC.CancelBtnText>
            </Button>
            <PlainTooltip
                enabled={isDisabled}
                tooltipContent={translate(TOOLTIP_DISABLED_TEXT)}
            >
                <span>
                    <Button
                        isDisabled={isDisabled}
                        type="primary"
                        onClick={onSave}
                        isLoading={isLoading}
                        dataAutomation={settingsActionsKeys.save}
                    >
                        <SC.PrimaryBtnText>{translate(SAVE)}</SC.PrimaryBtnText>
                    </Button>
                </span>
            </PlainTooltip>
        </SC.ButtonGroupWrapper>
    </SC.SettingsActionsContainer>
));

export default SettingsActions;

SettingsActions.displayName = "SettingsActions";
